import { render, staticRenderFns } from "./CirclesList.vue?vue&type=template&id=34be52b1"
import script from "./CirclesList.vue?vue&type=script&lang=js"
export * from "./CirclesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports